import ProcessRoutes from "../reporting/process.js";
import ContainerRoutes from "./container.js";

export default [...ProcessRoutes, ...ContainerRoutes];
